import React from "react";

import {
  LocationHourLine,
  LocationHourValue,
  LocationHours,
} from "./BaseCard.styles";
import { splitHoursMetadataLine } from "../Finder/splitHoursMetadataLine";

interface PhlebotomyCardMetadataProps {
  lines: string[];
  plainLines?: string[];
  keyPrefix: string;
  splitHours?: boolean;
}

const PhlebotomyCardMetadata: React.FC<PhlebotomyCardMetadataProps> = ({
  lines,
  plainLines = [],
  keyPrefix,
  splitHours = true,
}) => {
  if (lines.length === 0 && plainLines.length === 0) return null;

  return (
    <LocationHours>
      {lines.map((line) => {
        const { label, value } = splitHours
          ? splitHoursMetadataLine(line)
          : { label: null, value: line };
        return (
          <LocationHourLine key={`${keyPrefix}-${line}`}>
            {label != null ? (
              <>
                {label} <LocationHourValue>{value}</LocationHourValue>
              </>
            ) : (
              value
            )}
          </LocationHourLine>
        );
      })}
      {plainLines.map((line) => (
        <LocationHourLine key={`${keyPrefix}-plain-${line}`}>
          {line}
        </LocationHourLine>
      ))}
    </LocationHours>
  );
};

export default PhlebotomyCardMetadata;
